import * as e from "react";
import r from "@babel/runtime/helpers/esm/extends";
var t = {
  prefix: Math.round(1e10 * Math.random()),
  current: 0
},
    n = /*#__PURE__*/e.createContext(t);
export var IdProvider = function IdProvider(o) {
  var i = e.useContext(n),
      s = i === t,
      a = e.useMemo(function () {
    return {
      prefix: s ? 0 : ++i.prefix,
      current: 0
    };
  }, [s, i]);
  /*#__PURE__*/

  return e.createElement(n.Provider, r({
    value: a
  }, o));
};
export function useId(r) {
  var o = e.useContext(n);
  return Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) || o !== t || console.warn("When server rendering, you must wrap your application in an <IdProvider> to ensure consistent ids are generated between the client and server."), e.useMemo(function () {
    return r || "radix-id-".concat(o.prefix, "-").concat(++o.current);
  }, [r]);
}